import { createSlice } from "@reduxjs/toolkit";
import { registrationAccount as initialState } from "../initialState";

export const slice = createSlice({
    name: "registrationAccount",
    initialState,
    reducers: {
        updateRegistrationAccount: (state, action) => ({
            ...state,
            ...action.payload,
        }),
        updateRegistrationAccountFormView: (state, action) => {
            state.form.formView = action.payload;
        },
        updateRegistrationAccountHasActivatedAccount: (state, action) => {
            state.global.hasActiveGlobalAccount = action.payload;
        },
        updateRegistrationAccountIsLoggedIn: (state, action) => {
            state.global.isLoggedIn = action.payload;
        },
        updateRegistrationAccountSubmitted: (state, action) => {
            state.form.submitted = action.payload;
        },
        updateRegistrationAccountSubmittedMessage: (state, action) => {
            state.form.submittedMessage = action.payload;
        },
        updateRegistrationAccountValidation: (state, action) => {
            if (state?.validation) {
                state.validation = { ...state.validation, ...action.payload };
            }
        },
        // -------------------------------------------------------------------------
        // TODO: Make sure this is behaving properly once all hooked up
        // -------------------------------------------------------------------------
        replaceRegistrationAccountState: (state, action) => action.payload,
    },
});

// actions
export const {
    updateRegistrationAccount,
    updateRegistrationAccountFormView,
    updateRegistrationAccountHasActivatedAccount,
    updateRegistrationAccountIsLoggedIn,
    updateRegistrationAccountSubmitted,
    updateRegistrationAccountSubmittedMessage,
    updateRegistrationAccountValidation,
    replaceRegistrationAccountState,
} = slice.actions;

// selectors
export const selectRegistrationAccount = (state) => state.registrationAccount;

export const selectRegistrationAccountFormData = (state) =>
    state.registrationAccount.form;

export const selectRegistrationAccountGlobalData = (state) =>
    state.registrationAccount.global;

export const selectRegistrationAccountContactData = (state) =>
    state.registrationAccount.contact;

export const selectRegistrationAccountUrlData = (state) =>
    state.registrationAccount.url;

export const selectHasActiveGlobalAccount = (state) =>
    state.registrationAccount.global.hasActiveGlobalAccount;

export default slice.reducer;
